import { useWebTrafficKPIs } from '@/api/webTraffic';
import { usePageFilterContext } from '@/components/page';
import { CHANNEL_ID_PAID_SEARCH } from '@/constants';
import { TrafficKPIs } from '@/features/TrafficKPIs';

const PaidSearchOverviewKPIMetrics = () => {
  const {
    pageFilters: { startDate, endDate, audience },
  } = usePageFilterContext();

  const { webTrafficKPIs, isLoading, error } = useWebTrafficKPIs(startDate, endDate, audience, {
    channelIds: [CHANNEL_ID_PAID_SEARCH],
  });

  return <TrafficKPIs trafficKPIData={webTrafficKPIs} isLoading={isLoading} error={error} />;
};

export default PaidSearchOverviewKPIMetrics;
